const DEFAULTS = {
  title: 'Imóveis Mendicino',
  description: 'Imóveis à venda em Minas Gerais - Casas, Apartamentos, Lotes e mais',
  image: '/logo512.png',
  url: '/',
};

function getMeta(property: string): HTMLMetaElement | null {
  return document.querySelector(`meta[property="${property}"]`);
}

function setMeta(property: string, content: string) {
  let el = getMeta(property);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function setSEO({
  title,
  description,
  image,
  url,
}: {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}) {
  const origin = window.location.origin;

  if (title) {
    document.title = title;
    setMeta('og:title', title);
    console.log('[SEO] og:title →', title);
  }
  if (description) {
    setMeta('og:description', description);
    console.log('[SEO] og:description →', description);
  }
  if (image) {
    const imgUrl = image.startsWith('http') ? image : `${origin}${image}`;
    setMeta('og:image', imgUrl);
    console.log('[SEO] og:image →', imgUrl);
  }
  if (url) {
    const pageUrl = url.startsWith('http') ? url : `${origin}${url}`;
    setMeta('og:url', pageUrl);
    console.log('[SEO] og:url →', pageUrl);
  }
}

export function resetSEO() {
  document.title = DEFAULTS.title;
  setMeta('og:title', DEFAULTS.title);
  setMeta('og:description', DEFAULTS.description);
  setMeta('og:image', `${window.location.origin}${DEFAULTS.image}`);
  setMeta('og:url', `${window.location.origin}${DEFAULTS.url}`);
  console.log('[SEO] reset to defaults');
}
